export default __webpack_public_path__ + "static/ActivityCardMichael-b10d7ef0a07d27e59658ae47f626c907.png";